import { render, staticRenderFns } from "./ClientEmailNotificationForm.vue?vue&type=template&id=5fd40ffe&"
import script from "./ClientEmailNotificationForm.vue?vue&type=script&lang=js&"
export * from "./ClientEmailNotificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports